/**
 * NDG Event List — view.js
 *
 * Enregistre le namespace Interactivity API.
 * Le rendu initial est SSR (wp_interactivity_state + data-wp-each).
 * Le tri géographique est géré par vanilla JS (data-lat / data-lng sur les <li>).
 */

import { store } from '@wordpress/interactivity';

store( 'ndg/event-list', {} );
